export default __webpack_public_path__ + "static/media/View Draft Agenda pdf.bd8e706e.pdf";